import { Link } from "react-router-dom";
import { Product } from "./data/products";

interface ProductHubProps {
  eyebrow: string;
  heading: string;
  lede: string;
  products: Product[];
  /** Wording on each card's button, e.g. "View app" or "View game". */
  cta: string;
}

/**
 * The listing shared by the apps and games hubs.
 *
 * Extracted rather than copied: the two pages differ only in their wording, and a
 * duplicated grid would have drifted the first time either one was touched.
 */
export const ProductHub: React.FC<ProductHubProps> = ({
  eyebrow,
  heading,
  lede,
  products,
  cta,
}) => {
  return (
    <div id={`div-application-${eyebrow.toLowerCase()}`} className="div application-apps">
      <section className="block block-tight">
        <div className="wrap">
          <div className="eyebrow">{eyebrow}</div>
          <h3 className="section-head">{heading}</h3>
          <p className="lede">{lede}</p>

          <div className="grid-2" style={{ marginTop: "48px" }}>
            {products.map((product) => (
              <div className="panel apps-hub-card" key={product.id}>
                <div className="icon-wrap">
                  <img src={product.icon} alt={`${product.name} app icon`} />
                </div>
                <div>
                  <h4>
                    {product.name}
                    {product.comingSoon && (
                      <span className="coming-soon-tag">Coming soon</span>
                    )}
                  </h4>
                  <p>{product.hubSummary}</p>
                  <Link
                    className="btn-stm btn-stm-secondary btn-stm-small"
                    to={product.path}
                  >
                    {cta} &rarr;
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};
